module.exports = __webpack_public_path__ + "static/media/copyToClipboard.307215bb.svg";